<div class="cont-input" *ngIf="!!form">
  <fieldset #inputData class="input {{style}}" [class.active]="isActivate" [class.error]="isErrorActivate" [class.not-placeholder]="isEmptyPlaceholder">
    <label *ngIf="!isEmptyPlaceholder">{{placeholder}}</label>
    <i aria-hidden="true" class="icon-edit" (click)="focusInput(inputDataRef)" ></i>
    <ng-container [formGroup]="form">
      <input currencyMask
        autocomplete="off"
        [id]="id"
        type="tel"
        class="input {{style}}"
        [(ngModel)]="inputValue"
        [class.not-placeholder]="isEmptyPlaceholder"
        [placeholder]="placeholder"
        [attr.maxlength]="14"
        [formControlName]="formControlSelector"
        (blur)="changeValue($event.target.value)">
    </ng-container>
    <span *ngIf="isErrorActivate" class="only-error error">
      {{'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.' + errorMessage | transloco: { price: errorPrice | currencyFormat : currencyCode } }}
    </span>
  </fieldset>
</div>
